import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { isEmpty, round } from 'lodash';

import Color from '@tool/color';
import moDemandPdf from '../store';

interface IProps {}
interface IState {}

const ComapnyTable = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { companyIndsutryListTime } = moDemandPdf;

  useEffect(() => {
    return () => {};
  }, []);

  const colorList = ['', Color.cf, Color.primary, Color.secondary];

  return (
    <section className="company-table-warp">
      <section className="table-title">
        {['', '扩招公司占比', '平招公司占比', '缩招公司占比'].map(
          (res: any, i: any) => {
            return (
              <p key={i} style={{ background: colorList[i] }}>
                {res}
              </p>
            );
          },
        )}
      </section>
      <section className="table-content">
        {companyIndsutryListTime?.map((res: any, i: any) => {
          return (
            <p key={i}>
              <span>{res.time_str}</span>
              <span>{`${round(res.increase_ratio * 100, 1)}%`}</span>
              <span>{`${round(res.unchange_ratio * 100, 1)}%`}</span>
              <span>{`${round(res.decrease_ratio * 100, 1)}%`}</span>
            </p>
          );
        })}
      </section>
    </section>
  );
};

export default observer(ComapnyTable);
